import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const chatV3Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Chat element to v3 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'chat'>): void => {
    const chatProps = props;

    if (chatProps?.style?.general?.title && !chatProps?.content?.title?.iconColor) {
      const currentColor = chatProps.style.general.title.color1;
      chatProps.content = {
        ...chatProps.content,
        title: {
          ...chatProps.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
